import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

export const tickIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 46"><path d="M62.856 1.71c1.542 1.931 1.507 4.8.003 6.683l-.406.449L23.328 46.98l-.425.317-.476.271-.617.246-.452.113-.515.066-.424.006-.508-.05-.555-.129-.495-.184-.402-.205-.46-.304-.311-.256-.35-.35-16-17.684c-1.784-1.974-1.784-5.173 0-7.146 1.649-1.822 4.242-1.962 6.035-.42l.43.42 12.965 14.325L56.404 1.264c1.893-1.846 4.782-1.647 6.452.446z"></path></svg>`
);
